module.exports = __webpack_public_path__ + "static/img/header2Background.b91dacf2.png";